import { useTranslation } from "react-i18next";
import OrgFiltersSection from "@/components/Shared/Filters/OrgFiltersSection";
import LoadingIndicator from "@/components/Shared/LoadingIndicator/LoadingIndicator";
import { EMPTY_CUSTOMER_DEFINITION } from "@/models/CustomerFilter";
import { useOrganisation, useUpdateOrganisation } from "@/networking/organisation.hooks";
import CustomerFilterBuilder from "@/pages/Customers/components/CustomerFilterBuilder";
import { useCustomerFilterData } from "@/pages/Customers/components/useCustomerFilterData";

const KundfilterPage = () => {
	const { t } = useTranslation();
	const { data: organisation } = useOrganisation();
	const { mutate: updateOrganisation, isLoading: isSaving } = useUpdateOrganisation();
	const { options, isLoading } = useCustomerFilterData();

	if (isLoading) return <LoadingIndicator />;

	return (
		<div className="max-w-2xl">
			<OrgFiltersSection
				title={t("ORG_CUSTOMER_FILTERS" as any)}
				description={t("ORG_CUSTOMER_FILTERS_DESC" as any)}
				kbTag="customer-filters"
				emptyTitle={t("ORG_CUSTOMER_FILTERS_EMPTY_TITLE" as any)}
				emptyDesc={t("ORG_CUSTOMER_FILTERS_EMPTY_DESC" as any)}
				filters={organisation?.customerFilters ?? []}
				isSaving={isSaving}
				onSave={(next) => updateOrganisation({ customerFilters: next } as any)}
				emptyDefinition={EMPTY_CUSTOMER_DEFINITION}
				renderBuilder={(def, change) => (
					<CustomerFilterBuilder definition={def} onChange={change} options={options} />
				)}
			/>
		</div>
	);
};

export default KundfilterPage;
